<div class="notification notification-{{ severity | lowercase }}">
    {{ code | notificationText }}

    <button *ngIf="showCloseButton" i18n class="button" (click)="closeClicked.emit()">Clear</button>
</div>
